<template>
  <form id="create_banner_form">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">افزودن بنر</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>عنوان</label>
              <input
                type="text"
                name="title"
                v-model="form.title"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>لینک</label>
              <input
                type="text"
                name="title"
                dir="ltr"
                v-model="form.link"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>مشاهده برای</label>
              <select class="form-control" v-model="form.type">
                <option value="1">همه</option>
                <option value="2">کاربران بدون کمپانی</option>
                <option value="3">کاربران کمپانی‌ها</option>
                <option value="4">کاربران دارای بخش مالی</option>
                <option value="5">مدیران</option>
              </select>
            </div>
          </div>
          <div class="col-md-6" v-if="form.type === '3'">
            <label>انتخاب کمپانی</label>
            <b-form-select
              v-model="form.company"
              :options="companiesList"
              class="form-control mb-3"
              value-field="id"
              text-field="title"
            >
              <template #first>
                <b-form-select-option :value="null">
                  همه
                </b-form-select-option>
              </template>
            </b-form-select>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>عرض</label>
              <select class="form-control" v-model="form.width">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="19">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>بنر اصلی (xs)</label>
              <div class="custom-file">
                <input
                  type="file"
                  accept="image/*"
                  class="custom-file-input"
                  ref="xs_file"
                  id="xs_file"
                  @change="fileChanged"
                />
                <label class="custom-file-label" for="xs_file"></label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>sm (اختیاری)</label>
              <div></div>
              <div class="custom-file">
                <input
                  type="file"
                  accept="image/*"
                  class="custom-file-input"
                  ref="sm_file"
                  id="sm_file"
                  @change="fileChanged"
                />
                <label class="custom-file-label" for="sm_file"></label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>md (اختیاری)</label>
              <div></div>
              <div class="custom-file">
                <input
                  type="file"
                  accept="image/*"
                  class="custom-file-input"
                  ref="md_file"
                  id="md_file"
                  @change="fileChanged"
                />
                <label class="custom-file-label" for="md_file"></label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>lg (اختیاری)</label>
              <div></div>
              <div class="custom-file">
                <input
                  type="file"
                  accept="image/*"
                  class="custom-file-input"
                  ref="lg_file"
                  id="lg_file"
                  @change="fileChanged"
                />
                <label class="custom-file-label" for="lg_file"></label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>xl (اختیاری)</label>
              <div></div>
              <div class="custom-file">
                <input
                  type="file"
                  accept="image/*"
                  class="custom-file-input"
                  ref="xl_file"
                  id="xl_file"
                  @change="fileChanged"
                />
                <label class="custom-file-label" for="xl_file"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { STORE_ADMIN_BANNER } from "@/core/services/store/admin/banners.module";
import { mapGetters } from "vuex";
import { FETCH_ADMIN_COMPANIES } from "@/core/services/store/admin/users.module.js";

export default {
  name: "banners-create",
  props: ["id"],
  data() {
    return {
      form: {
        title: "",
        link: "",
        company: null,
        type: "1",
        width: "12"
      },
      progressMode: true,
      filePath: ""
    };
  },
  mounted() {
    this.setBreadcrumbs();
    this.setActions();

    this.eventHub.$on("save-banner-event", this.save);

    this.fv = formValidation(document.getElementById("create_banner_form"), {
      fields: {
        title: {
          validators: {
            notEmpty: {
              message: "عنوان صحیح نیست"
            },
            stringLength: {
              min: 3,
              max: 128,
              message: "عنوان صحیح نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
    this.updateCompanies();
  },
  beforeDestroy() {
    this.eventHub.$off("save-banner-event");
    document.getElementById("save-banner-btn").disabled = false;
  },
  computed: {
    ...mapGetters(["adminCompanies"]),
    companiesList() {
      return JSON.parse(JSON.stringify(this.adminCompanies));
    }
  },
  methods: {
    updateCompanies() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_ADMIN_COMPANIES)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    setBreadcrumbs() {
      let bannersRouteName = "banners-index";

      let items = [];
      items.push({ title: "پنرها", route: { name: bannersRouteName } });
      items.push({ title: "افزودن" });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      let bannersRouteName = "admin-banners-index";

      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "ذخیره",
            event: "save-banner-event",
            class: "btn-primary",
            id: "save-banner-btn"
          }
        ],
        links: [
          {
            name: "بازگشت",
            to: { name: bannersRouteName }
          }
        ]
      });
    },
    fileChanged(e) {
      if (e.target.files && e.target.files[0]) {
        e.target.nextElementSibling.innerHTML = e.target.files[0].name;
        e.target.nextElementSibling.classList.add("selected");
      } else {
        e.target.nextElementSibling.innerHTML = "";
        e.target.nextElementSibling.classList.remove("selected");
      }
    },
    save() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("save-banner-btn");
          this.disableBtn(submitBtn);

          let formData = new FormData();
          formData.append("title", this.form.title);
          formData.append("link", this.form.link);
          formData.append("type", this.form.type);
          formData.append("width", this.form.width);

          if (this.form.company) {
            formData.append("company", this.form.company);
          }

          if (this.$refs.xs_file.files && this.$refs.xs_file.files[0]) {
            formData.append("xs", this.$refs.xs_file.files[0]);
          }
          if (this.$refs.sm_file.files && this.$refs.sm_file.files[0]) {
            formData.append("sm", this.$refs.sm_file.files[0]);
          }
          if (this.$refs.md_file.files && this.$refs.md_file.files[0]) {
            formData.append("md", this.$refs.md_file.files[0]);
          }
          if (this.$refs.lg_file.files && this.$refs.lg_file.files[0]) {
            formData.append("lg", this.$refs.lg_file.files[0]);
          }
          if (this.$refs.xl_file.files && this.$refs.xl_file.files[0]) {
            formData.append("xl", this.$refs.xl_file.files[0]);
          }

          this.$store
            .dispatch(STORE_ADMIN_BANNER, formData)
            .then(() => {
              this.enableBtn(submitBtn);
              this.$router.push({
                name: "admin-banners-index"
              });
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    }
  }
};
</script>
